/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { AlertBar } from '@blend/enterprise-components';
import { ErrorType } from '../../types';
import { DEFAULT_ERROR_ALERT_MESSAGE, ERROR_ALERT_MESSAGES, HEADER_HEIGHT } from '../../constants';

const styles = StyleSheet.create({
  alertBarWrapper: {
    left: 0,
    margin: 'auto',
    maxWidth: 820,
    position: 'fixed',
    right: 0,

    top: HEADER_HEIGHT,
    zIndex: 10,
  },
});

export interface ErrorAlertProps {
  dismiss: () => void;
  type: ErrorType;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ type, dismiss }) => {
  const getAlertProps = (): AlertBar.Props => {
    switch (type) {
      case 'LoadingError':
      case 'AcceptFeesError':
      case 'CreateRequestError':
        return {
          cancelProps: { cancelText: 'Dismiss', onCancel: dismiss },
          icon: 'error',
          message: ERROR_ALERT_MESSAGES[type],
          theme: 'error',
        };
      case 'LockError':
        return {
          icon: 'lock',
          message: ERROR_ALERT_MESSAGES[type],
          theme: 'warn',
        };
      default:
        return {
          cancelProps: { cancelText: 'Dismiss', onCancel: dismiss },
          message: DEFAULT_ERROR_ALERT_MESSAGE,
          theme: 'error',
        };
    }
  };

  return (
    <div className={css(styles.alertBarWrapper)}>
      <AlertBar id="it-ClosingFees-ErrorAlert" {...getAlertProps()} shadow />
    </div>
  );
};
